import React from 'react';
import PropTypes from 'prop-types';
import Ellipsis from 'ellipsis.js';
import EllipsisReadMore from '../../shared/ellipsis-read-more';

export default class TruncatedEllipsis extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.configure();
  }

  componentDidMount() {
    if (this.ellipsis && this.truncateContainer) {
      this.ellipsis.add(this.truncateContainer);
    }
  }

  // Turn off react because we mutate with Ellipsis|More
  shouldComponentUpdate() {
    return false;
  }

  configure() {
    const { lines, useReadMore } = this.props;
    const opt = {
      ellipsis: '…', // default ellipsis value
      debounce: 500, // if you want to chill out your memory usage on resizing
      responsive: true, // if you want the ellipsis to move with the window resizing
      className: false, // use manual truncate
      lines, // default number of lines when the ellipsis will appear
      break_word: true, // default the ellipsis can truncate words
    };
    this.ellipsis = useReadMore ? EllipsisReadMore(opt) : Ellipsis(opt);
  }

  render() {
    const { summary, hasTags } = this.props;
    if (hasTags) {
      return (
        <span
          ref={node => (this.truncateContainer = node)}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: summary }}
        />
      );
    }

    return <span ref={node => (this.truncateContainer = node)}>{summary}</span>;
  }
}

TruncatedEllipsis.propTypes = {
  lines: PropTypes.number.isRequired,
  summary: PropTypes.string.isRequired,
  useReadMore: PropTypes.bool,
  hasTags: PropTypes.bool,
};

TruncatedEllipsis.defaultProps = {
  useReadMore: true,
  hasTags: true,
};
